import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { WalletPinHttpProvider } from './helpers/provider/repository/wallet-pin-http-repository.provider';

const DATA_SERVICES: Provider[] = WalletPinHttpProvider;

export const NB_CORE_PROVIDERS = [...DATA_SERVICES];

@NgModule({})
export class WalletAccountCoreModule {
    static forRoot(): ModuleWithProviders<WalletAccountCoreModule> {
        return {
            ngModule: WalletAccountCoreModule,
            providers: [...NB_CORE_PROVIDERS],
        };
    }
}
